/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`g/mol`)
};

const es_dnamw_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`g/mol`)
};

const de_dnamw_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`g/mol`)
};

const nl_dnamw_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`g/mol`)
};

const fr_dnamw_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`g/mol`)
};

const it_dnamw_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`g/mol`)
};

const pt_br2_dnamw_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`g/mol`)
};

const pt_dnamw_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`g/mol`)
};

const ja_dnamw_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`g/mol`)
};

const zh_dnamw_unit = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`g/mol`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_unit = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_unit(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_unit", locale)
	if (locale === "en") return en_dnamw_unit(inputs)
	if (locale === "es") return es_dnamw_unit(inputs)
	if (locale === "de") return de_dnamw_unit(inputs)
	if (locale === "nl") return nl_dnamw_unit(inputs)
	if (locale === "fr") return fr_dnamw_unit(inputs)
	if (locale === "it") return it_dnamw_unit(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_unit(inputs)
	if (locale === "pt") return pt_dnamw_unit(inputs)
	if (locale === "ja") return ja_dnamw_unit(inputs)
	return zh_dnamw_unit(inputs)
};